<template>
  <v-card style="padding: 16px" class="mx-auto">
    <v-card-text>
      <v-card-actions class="headline font-weight-bold">
        <h3>Comissões</h3>
        <v-spacer></v-spacer>
      </v-card-actions>

      <v-layout row wrap>
        <v-flex xs12 md6>
          <v-card class="ma-2" color="#3e9c35" dark>
            <v-card-text>
              <div class="caption">A receber (pendente)</div>
              <div class="headline">{{ $n(summary.pending || 0, "currency") }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 md6>
          <v-card class="ma-2" color="#607D8B" dark>
            <v-card-text>
              <div class="caption">Já recebido</div>
              <div class="headline">{{ $n(summary.paid || 0, "currency") }}</div>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        class="elevation-1"
        no-data-text="Nenhuma comissão ainda."
      >
        <template slot="items" slot-scope="props">
          <td>{{ formatDate(props.item.created_at) }}</td>
          <td>{{ labelKind(props.item.fee_kind) }}</td>
          <td class="text-xs-right">{{ fmt(props.item.rate) }}%</td>
          <td class="text-xs-right">{{ $n(props.item.amount, "currency") }}</td>
          <td>
            <v-chip
              :color="props.item.status === 'paid' ? 'green' : 'orange'"
              small
              text-color="white"
            >
              {{ statusLabel(props.item.status) }}
            </v-chip>
          </td>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import Flowit from "@/services/flowit";

export default {
  name: "partner-commissions",
  data() {
    return {
      loading: true,
      summary: { pending: 0, paid: 0, count: 0 },
      items: [],
      headers: [
        { text: "Data", sortable: false },
        { text: "Tipo", sortable: false },
        { text: "Taxa", sortable: false, align: "right" },
        { text: "Valor", sortable: false, align: "right" },
        { text: "Status", sortable: false },
      ],
      kindLabels: {
        credit: "Crédito",
        debit: "Débito",
        anticipation_automatic: "Antecipação automática",
        anticipation_manual: "Antecipação manual",
        pix: "PIX",
        boleto: "Boleto",
        withdraw: "Saque",
      },
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      Flowit.partners
        .commissions()
        .then((response) => {
          this.summary = response.data.summary || { pending: 0, paid: 0, count: 0 };
          this.items = response.data.items || [];
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    labelKind(kind) {
      return this.kindLabels[kind] || kind;
    },
    statusLabel(status) {
      const labels = { paid: "Recebido", cancelled: "Cancelado", pending: "Pendente" };
      return labels[status] || "Pendente";
    },
    fmt(value) {
      return (Number(value) || 0).toFixed(2);
    },
    formatDate(value) {
      if (!value) return "";
      return this.$d(new Date(value), "short");
    },
  },
};
</script>
